import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '@ztechapps/common.contract'
import type { FilterQuery, IAction, Template } from '@ztechapps/common.contract'

@InputType()
export class UpdateHaulerTemplateArgs extends ActionArgs {
  /** The fields to change on the catalog row; `category` and `scope` are stamped by the Action. */
  @Field(() => GraphQLJSON, { nullable: false })
  input: Partial<Template>

  /** Which catalog rows to update; the Action ANDs `category: 'hauler'` onto it. */
  @Field(() => GraphQLJSON, { nullable: true })
  filter?: FilterQuery<Template>
}

export interface IUpdateHaulerTemplate extends IAction<Template, UpdateHaulerTemplateArgs> {}
